import React from "react";
import styles from '../styles/Contact.module.css';
import FormInput from "./form/FormInput";
import Footer from './layout/Footer';

const Contact = () => {
    return (
        <div className={styles.page}>
            <div className={styles.contact}>
                <div className={styles.contactText}>
                    <p>문의 하기</p>
                </div>
                <span className={styles.backTitle}>CONTACT</span>
                <div className={styles.grid}>
                    <FormInput />
                </div>
                <div className={styles.divider}></div>
            </div>
            <Footer />
        </div>
    )
}

export default Contact;